import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AppRoutes } from 'src/app/app-routes';
import { TextErrorContentUI } from 'src/app/interfaces/text-content.interface';
import { ErrorToReturnContentName } from 'src/app/utils/constants';
import { ErrorContentName } from 'src/app/utils/enums';
import { ErrorTexts } from 'src/app/utils/text-content';

@Injectable({
	providedIn: 'root',
})
export class ErrorService {
	private errorTextSubject: BehaviorSubject<TextErrorContentUI> = new BehaviorSubject(
		ErrorTexts.GENERIC_ERROR
	);
	readonly errorText$ = this.errorTextSubject.asObservable();

	constructor(private readonly router: Router) {}

	handlerError(error: HttpErrorResponse): void {
		const errorContentName = this.errorSelector(error);
		this.setErrorTexts(errorContentName);

		this.router.navigate([AppRoutes.ERROR]);
	}

	errorSelector(error: HttpErrorResponse): ErrorContentName {
		if (!navigator.onLine) return ErrorContentName.NO_CONNECTION;

		if (error.status === 460)
			return ErrorToReturnContentName[error.error?.codigo] || ErrorContentName.GENERIC_ERROR;

		return ErrorContentName.GENERIC_ERROR;
	}

	setErrorTexts(errorContentName: ErrorContentName): void {
		this.errorTextSubject.next(ErrorTexts[errorContentName]);
	}
}
